<template>
  <div class="infoscreen-container">
    <TicketGreed
      v-if="tempTicket"
      ref="tempTicket"
      :style="{ display: showTempTicket ? 'flex' : 'none' }"
      :ticket="tempTicket"
    />
    <div
      v-for="(item, index) in currentItems"
      :key="item ? item.id : -(index + 1)"
      class="infoscreen-item"
      :style="{backgroundColor: $store.infoscreenData.infoboardBackgroundColor}"
    >
      <TicketGreed
        v-if="item"
        ref="ticketRef"
        :ticket="item"
      />
    </div>
  </div>
</template>

<script>
import TicketGreed from '../tickets/TicketGreed';
import TemplateMixin from '../../mixins/TemplateMixin';

export default {
  name: 'TemplateGreed',
  components: {
    TicketGreed
  },
  mixins: [TemplateMixin],
  computed: {
    currentItems() {
      return this.getCurrentTickets(6);
    }
  }
}
</script>

<style lang="scss" scoped>
.infoscreen-container {
  display: flex;
  flex-wrap: wrap;
  height: 100%;

  .infoscreen-item {
    width: 50%;
    height: 33.333%;
    padding: 0 2.5vw;
    border-bottom-style: solid;
    border-right-style: solid;

    &:nth-child(1),
    &:nth-child(2),
    &:nth-child(3),
    &:nth-child(4) {
      border-bottom-width: 8px;
      border-bottom-width: max(0.417vw, 8px);
    }

    &:nth-child(1),
    &:nth-child(3),
    &:nth-child(5) {
      border-right-width: 8px;
      border-right-width: max(0.417vw, 8px);
    }
  }
}
</style>

